import React, { useEffect, useState } from 'react';

import Axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import Config from '../config';
import { Dropdown } from 'primereact/dropdown';

const LogsProducts = () => {
    const [logsCount, setLogsCount] = useState();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 100,
        page: 1,
        sortField: 'time',
        sortOrder: -1,
        filters: {
          'aic': { value: null, matchMode: 'equals' },
          'type': { value: null, matchMode: 'equals' },
          'source': { value: null, matchMode: 'equals' },
          'context': { value: null, matchMode: 'equals' }
        }
    });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/logs/products", lazyParams)
            .then(result => result.data)
            .then(result => {
                setLogs(result.data.rows);
                setLogsCount(result.data.count);
                setLoading(false);
            });
    };

    const onFilter = params => {
        setLazyParams(_.merge(params, { first: 0 }));
    }
    const onSort = params => setLazyParams(params);
    const onPage = params => setLazyParams(params);

    const typeRowFilterTemplate = options => (
        <Dropdown
          value={options.value}
          options={[
            {name: 'Quantità', code: 'quantity'},
            {name: 'Prezzo', code: 'price'},
            {name: 'Archivio', code: 'archive'},
            {name: 'Aggiunto', code: 'add'},
            {name: 'Cancellato', code: 'delete'}
          ]}
          optionLabel="name"
          onChange={(e) => options.filterApplyCallback(e.value)}
          placeholder="Scegli un tipo"
          className="p-column-filter"
        />
    );
    const sourceRowFilterTemplate = options => (
        <Dropdown
          value={options.value}
          options={['Gestionale', 'Guacci', 'Sofarma', 'Farvima', 'Congedo', 'Vim', 'Cef']}
          onChange={(e) => options.filterApplyCallback(e.value)}
          placeholder="Scegli un'origine"
          className="p-column-filter"
        />
    );

    const rowDatetime = row => moment(row.time).format('D MMM HH:mm:ss');
    const rowAIC = row => row.aic || row.sku;
    const rowType = row => _.defaultTo(row.context.type, row.message);
    const rowData = row => {
        if (row.message === 'Update price') {
            return <>
                Costo: <strong>{row.cost}</strong> -
                Prezzo: <strong>{row.price}</strong> -
                Listino: <strong>{row.suggested_price}</strong>
            </>;
        }
        else if (row.message === 'Update quantity') {
            return row.quantity;
        }
        else if (row.context.type === 'tags') {
            return row.context.tags;
        }
        else {
          return '';
        }
    };
    const rowSource = row => row.message === 'Update price' ? row.wholesaler : '';

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Log sincronizzazione prodotti</h5>
                    <DataTable
                      className="p-datatable-gridlines"
                      responsiveLayout="scroll"
                      lazy
                      dataKey="id"
                      value={logs}
                      paginator
                      showGridlines
                      first={lazyParams.first}
                      rows={lazyParams.rows}
                      totalRecords={logsCount}
                      filters={lazyParams.filters}
                      filterDisplay="row"
                      onFilter={onFilter}
                      sortField={lazyParams.sortField}
                      sortOrder={lazyParams.sortOrder}
                      onSort={onSort}
                      onPage={onPage}
                      loading={loading}
                      emptyMessage="Nessun log trovato."
                    >
                      <Column field="id" body={rowDatetime} header="Data e ora" sortable style={{ maxWidth: '100px' }} />
                      <Column key="aic" body={rowAIC} header="AIC" field="aic" filter showFilterMenu={false} style={{ maxWidth: '100px' }} />
                      <Column field="type" body={rowType} filter showFilterMenu={false} filterElement={typeRowFilterTemplate} header="Tipo" style={{ maxWidth: '130px' }} />
                      <Column body={rowData} header="Dati" field="context" filter showFilterMenu={false} />
                      <Column field="source" body={rowSource} filter showFilterMenu={false} filterElement={sourceRowFilterTemplate} header="Origine" style={{ maxWidth: '100px' }} />
                      {/*
                      <Column field="message" header="Messaggio" />
                      {/*
                      <Column field="name" header="Name" filter filterPlaceholder="Search by name" style={{ minWidth: '12rem' }} />
                      <Column header="Country" filterField="country.name" style={{ minWidth: '12rem' }} body={countryBodyTemplate} filter filterPlaceholder="Search by country"
                          filterClear={filterClearTemplate} filterApply={filterApplyTemplate} />
                      <Column header="Agent" filterField="representative" showFilterMatchModes={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '14rem' }} body={representativeBodyTemplate}
                          filter filterElement={representativeFilterTemplate} />
                      <Column header="Date" filterField="date" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate}
                          filter filterElement={dateFilterTemplate} />
                      <Column header="Balance" filterField="balance" dataType="numeric" style={{ minWidth: '10rem' }} body={balanceBodyTemplate} filter filterElement={balanceFilterTemplate} />
                      <Column field="status" header="Status" filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} body={statusBodyTemplate} filter filterElement={statusFilterTemplate} />
                      <Column field="activity" header="Activity" showFilterMatchModes={false} style={{ minWidth: '12rem' }} body={activityBodyTemplate} filter filterElement={activityFilterTemplate} />
                      <Column field="verified" header="Verified" dataType="boolean" bodyClassName="text-center" style={{ minWidth: '8rem' }} body={verifiedBodyTemplate} filter filterElement={verifiedFilterTemplate} />
                      */}
                    </DataTable>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(LogsProducts, comparisonFn);
